import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-external-empty',
  templateUrl: './external.component.html',
  styleUrls: ['./external.component.scss'],
})

export class ExternalComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
